/** Landing physics for falling bottles. */
export interface BottlePhysicsTune {
  /** Downward accel while falling (px/s² → Matter gravity.scale). */
  gravity: number;
  /** CoM toward the base + cap-recovery torque. Higher = more likely to fall on a side. */
  tipGravity: number;
  /** Bounce restitution 0–1. */
  bounce: number;
  /** First-hit speed (px/s) that still counts as a bounce. */
  bounceCut: number;
  /** After the first bounce, ignore slower hops than this. */
  bounceCutLand: number;
  /** Air drag (Matter frictionAir). */
  airDamp: number;
  /** Extra spin damping while touching the floor. */
  groundDamp: number;
  /** Static friction once it is resting on a face. */
  faceDamp: number;
  /** Kinetic friction — slide along the floor. */
  slideDamp: number;
  /** How wild the tumble is when a bottle spawns. */
  airSpin: number;
  /** Clamp on angular velocity (rad/s). */
  spinCap: number;
  /** Pixels to sink the sprite into the floor / shadow. */
  sitOverlap: number;
  /** Matter contact slop + position iterations. */
  slop: number;
  /** Seconds of low motion before Matter sleeps the body. */
  sleepStill: number;
  /** How long a settled bottle stays on the floor. */
  groundRest: number;
}

export const DEFAULT_BOTTLE_PHYSICS: BottlePhysicsTune = {
  gravity: 60,
  tipGravity: 714,
  bounce: 0.13,
  bounceCut: 119,
  bounceCutLand: 180,
  airDamp: 1.19,
  groundDamp: 3.576,
  faceDamp: 7.78,
  slideDamp: 4.7,
  airSpin: 1.58,
  spinCap: 5.56,
  sitOverlap: 3,
  slop: 1.4,
  sleepStill: 0.1714,
  groundRest: 1.85,
};
